import React from 'react';
import styled, { css } from 'styled-components';

const titleCss = css`
  margin-top: 20px;
  margin-bottom: 20px;

  line-height: ${({ theme }) => theme.font.typography.h1.lineHeight.xs};
  font-size: ${({ theme }) => theme.font.typography.h1.size.xs};
  @media ${({ theme }) => theme.breakpoint.lg} {
    line-height: ${({ theme }) => theme.font.typography.h1.lineHeight.md};
    font-size: ${({ theme }) => theme.font.typography.h1.size.md};
  }

  color: ${({ theme }) => theme.colors.primary};
  .title-grey {
    color: ${({ theme }) => theme.colors.grey600};
  }
  .title-pink {
    color: ${({ theme }) => theme.colors.secondary};
  }
`;

const TitleH1Component = styled.h1`
  ${titleCss}
`;

const TitleH2Component = styled.h2`
  ${titleCss}
`;

const TitleComponent = ({ children, useTag }) => {
  if (useTag === 'h1') {
    return <TitleH1Component>{children}</TitleH1Component>;
  }
  return <TitleH2Component>{children}</TitleH2Component>;
};

const Title = ({ children, ...props }) => {
  return <TitleComponent {...props}>{children}</TitleComponent>;
};

export default Title;
